import { handleResponse, handleError } from './response';
import { usePortfolioStore } from '@/store/usePortfolioStore';

function getAxiosInstance() {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$api;
}

/**
 * Build request config with auth and portfolio header
 * @param {Object} config - Optional config overrides
 * @param {number|null} config.portfolioId - Portfolio ID for X-Portfolio-Id header (overrides active portfolio)
 * @param {boolean} config.skipPortfolioHeader - Skip adding portfolio header (for portfolio management endpoints)
 */
function getConfig(config = {}) {
  const token = localStorage.getItem('token');
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  // Add portfolio header unless skipped
  if (!config.skipPortfolioHeader) {
    // Use explicit portfolioId if provided, otherwise get from store
    let portfolioId = config.portfolioId;
    if (!portfolioId) {
      try {
        const portfolioStore = usePortfolioStore();
        portfolioId = portfolioStore.effectivePortfolioId;
      } catch (e) {
        // Store may not be available during SSR or initial load
      }
    }
    if (portfolioId) {
      headers['X-Portfolio-Id'] = String(portfolioId);
    }
  }

  return {
    ...config,
    headers: {
      ...headers,
      ...(config.headers || {}),
    },
  };
}

const get = (path, config = {}) => getAxiosInstance().get(`${path}`, { ...getConfig(config), ...config }).then(handleResponse).catch(handleError);
const post = (path, payload, config = {}) => getAxiosInstance().post(path, payload, { ...getConfig(config), ...config }).then(handleResponse).catch(handleError);
const put = (path, payload, config = {}) => getAxiosInstance().put(path, payload, { ...getConfig(config), ...config }).then(handleResponse).catch(handleError);
const patch = (path, payload, config = {}) => getAxiosInstance().patch(path, payload, { ...getConfig(config), ...config }).then(handleResponse).catch(handleError);
const del = (path, id, config = {}) => getAxiosInstance().delete(`${path}/${id}`, { ...getConfig(config), ...config }).then(handleResponse).catch(handleError);
const deleteRequest = (path, config = {}) => getAxiosInstance().delete(path, { ...getConfig(config), ...config }).then(handleResponse).catch(handleError);

export default {
  get,
  post,
  put,
  patch,
  del,
  delete: deleteRequest,
  getAxiosInstance,
  getConfig,
};
